import { Link } from "react-router-dom";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { PurchaseSteps } from "@/components/PurchaseSteps";
import { PANEL_INTRO, PROFILES, sampleCard } from "@/lib/panels";

export default function PanelsCatalogue() {
  return (
    <div data-testid="panels-catalogue" className="bg-white">
      <Breadcrumbs
        items={[
          { label: "Our Collection", to: "/collection" },
          { label: "Timber Collection", to: "/collections/timber" },
          { label: "Architectural Panels" },
        ]}
      />

      <section className="edge pt-8 pb-14 md:pt-12" data-testid="panels-intro">
        <span className="eyebrow">{PANEL_INTRO.eyebrow}</span>
        <h1 className="mt-5 text-4xl font-light leading-[1.02] tracking-editorial md:text-6xl">
          {PANEL_INTRO.title}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
          {PANEL_INTRO.intro}
        </p>
      </section>

      {/* Profile catalogue */}
      <section className="edge pb-24 md:pb-32" data-testid="panels-grid">
        <div className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {PROFILES.map((p) => (
            <Reveal key={p.slug}>
              <Link
                to={`/collections/timber/architectural-panels/${p.slug}`}
                data-testid={`profile-card-${p.slug}`}
                className="group block"
              >
                <div className="aspect-[4/3] overflow-hidden bg-secondary/40" data-testid={`profile-card-image-${p.slug}`}>
                  <img
                    src={sampleCard(p.slug)}
                    alt={`${p.name} timber panel`}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    loading="lazy"
                  />
                </div>
                <div className="mt-4 flex items-baseline justify-between">
                  <h3 className="text-lg font-light tracking-editorial">{p.name}</h3>
                  <span className="text-base transition-transform duration-500 group-hover:translate-x-1">→</span>
                </div>
                <p className="mt-1 text-xs uppercase tracking-[0.14em] text-muted-foreground">
                  {p.dimensions}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <PurchaseSteps />
    </div>
  );
}
